export const SHOW_INVITES = 'showinvites';

export const getShowInvitesValue = (): boolean => {
  const params = new URLSearchParams(window.location.search);
  return params.get(SHOW_INVITES) === 'true';
};
